// Icons for Wire Drivers
import { BloxNXTIcon } from 'assets/BloxNXTIcon';
import CNNIcon from 'assets/brands/CNN';
import WordPressIcon from 'assets/brands/WordPress';
import StringrIcon from 'assets/brands/Stringr';
import APNewsIcon from 'assets/brands/APNews';
import YouTubeIcon from '@mui/icons-material/YouTube';
import RssFeedIcon from '@mui/icons-material/RssFeed';

export const getWireDriverIcons = (
  driver: string,
  size?: number | string,
  sxProps?: any,
): JSX.Element => {
  switch (driver) {
    case 'ap_media_api':
      return <APNewsIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'cnn':
      return <CNNIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'wordpress':
      return <WordPressIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'stringr':
      return <StringrIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'apnews':
      return <APNewsIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'youtube':
      return <YouTubeIcon sx={{ fontSize: size, ...sxProps }} />;
    case 'atom':
      return <RssFeedIcon sx={{ fontSize: size, ...sxProps }} />;
    default:
      return <BloxNXTIcon sx={{ fontSize: size, ...sxProps }} />;
  }
};
